// extracted by mini-css-extract-plugin
export default {"overlay":"ConfirmDialog_overlay__QaUq-","dialog":"ConfirmDialog_dialog__Kmnri","yesButton":"ConfirmDialog_yesButton__0fPIJ","noButton":"ConfirmDialog_noButton__E8NPx"};